import { containerYardConstants } from '../../_constants';

export function containerYards(state = {}, action) {
    switch (action.type) {
        case containerYardConstants.CY_FETCHING:
            return {
                ...state,
                cyFetching: true
            };
        case containerYardConstants.CY_FETCHED:
            return {
                ...state,
                cyFetching: false
            };
        case containerYardConstants.CY_SUBMITTING:
            return {
                ...state,
                cySubmitting: true
            };
        case containerYardConstants.CY_SUBMITTED:
            return {
                ...state,
                cySubmitting: false
            };
        case containerYardConstants.GET_CONTAINER_YARDS:
            return {
                ...state,
                containerYards: action.containerYards,
            };
        case containerYardConstants.GET_CONTAINER_YARD_BY_ID:
            return {
                ...state,
                containerYard: action.containerYard
            };
        case containerYardConstants.GET_ACTIVE_CONTAINER_YARDS:
            return {
                ...state,
                activeContainerYards: action.activeContainerYards,
            };
        default:
            return state;
    }
}